import React from 'react';
import './ProgressBar.css';

const ProgressBar = ({progress}) => {
    let progressStatus;
    let progressBar;
    let progressBarWidth;

    if(progress>=100) {
        progressStatus = 'Completed';
        progressBar = 'completed';
        progressBarWidth = '100%';
    } else {
        progressStatus = `In Progress - ${Math.round(progress)}% has been completed`;
        progressBar = 'inprogress';
        progressBarWidth = progress+"%";
    }
    
    return (
        <div className="progressbar-container">
            <div className={`progress-status ${progressBar}`}> {progressStatus} </div>
            <div className="fullbar">
                <div className={`${progressBar} progressbar`} style={{width: progressBarWidth}}></div>
            </div>
        </div>
    )
}

export default ProgressBar;


// WEBPACK FOOTER //
// ./src/components/main/projects/index/ProgressBar.js